import _ from 'lodash'
import { Set } from 'immutable'

import { GRID_SELLABLE_ITEM_COLORS } from 'constants/grid-constants'
import { nowTimestamp, sortTimeRecord } from 'utils/datetime'

import { DateRecord, DealRecord, SellableItemRecord, TimeRecord } from './grid-records'

export const recomputeGrid = () => ({
  gridRecomputeTime: nowTimestamp(),
})

export const createSellableItem = values => state => {
  const color = GRID_SELLABLE_ITEM_COLORS[state.nextColorIndex]
  const newSellableItem = new SellableItemRecord(values, color)
  const sellableItems = state.sellableItems.merge({
    [newSellableItem.id]: newSellableItem,
  })
  return {
    ...state,
    sellableItems,
    nextColorIndex: (state.nextColorIndex + 1) % GRID_SELLABLE_ITEM_COLORS.length,
  }
}

export const getOrCreateDate = dateKey => state => {
  const existingDate = state.dates.find(date => date.date === dateKey)
  if (!existingDate) {
    const newDate = new DateRecord(dateKey)
    return {
      updatedDateState: {
        ...state,
        dates: state.dates.set(newDate.id, newDate).sortBy(date => date.date),
      },
      date: newDate,
    }
  }

  return {
    updatedDateState: state,
    date: existingDate,
  }
}

export const getOrCreateTime = (hour, minute) => state => {
  const existingTime = state.times.find(time =>
    time.hour === parseInt(hour, 10) && time.minute === parseInt(minute, 10)
  )
  if (!existingTime) {
    const newTime = new TimeRecord(hour, minute)
    return {
      updatedTimeState: {
        ...state,
        times: state.times.set(newTime.id, newTime).sort(sortTimeRecord),
      },
      time: newTime,
    }
  }

  return {
    updatedTimeState: state,
    time: existingTime,
  }
}

export const createDeal = (dateId, timeId, sellableItemId, values) => state => {
  let deals = state.deals
  let datesToTimesToDeals = state.datesToTimesToDeals

  // Create an empty set of deals if one does not exist for the cell
  if (!datesToTimesToDeals.hasIn([dateId, timeId])) {
    datesToTimesToDeals = datesToTimesToDeals.setIn([dateId, timeId], new Set())
  }

  const existingSellableItem = datesToTimesToDeals.getIn([dateId, timeId]).some(dealId =>
    state.deals.get(dealId).sellableItemId === sellableItemId
  )

  if (!existingSellableItem) {
    // Add new deal to cell
    const newDeal = new DealRecord(values, sellableItemId)
    datesToTimesToDeals = datesToTimesToDeals.updateIn([dateId, timeId], dealSet => dealSet.add(newDeal.id))

    // Add deal to deals state
    deals = deals.set(newDeal.id, newDeal)
  }

  return {
    ...state,
    deals,
    datesToTimesToDeals,
  }
}

export const getMostCommonQuantity = sellableItemId => state =>
  _(state.deals.filter(deal => deal.sellableItemId === sellableItemId).map(deal => deal.ticketCount).toArray())
    .countBy().toPairs().sortBy(1).reverse().map(0).value()[0]



/** WEBPACK FOOTER **
 ** ./src/reducers/grid/grid-functions.js
 **/